import { Campaign } from '@/types/model';

declare global {
  interface Window {
    // dataLayer?: any[];
    lintrk?: (accion: string, datos?: Record<string, unknown>) => void;
  }
}

export const DEV = process.env.NODE_ENV !== 'production';

/**
 *
 * @returns Campaign intance
 */
const CLAVES_UTM = ['utm_source', 'utm_campaign', 'utm_term', 'utm_medium', 'utm_content'] as const;

function getAllUrlParams(url: string): Campaign {
  const query = url.includes('?') ? url.split('?')[1] : window.location.search.slice(1);
  const params = new URLSearchParams(query.split('#')[0]);
  const campaign: Campaign = {};

  for (const clave of CLAVES_UTM) {
    const valor = params.get(clave);
    if (valor) campaign[clave] = valor;
  }

  return campaign;
}

export const getCampaignData = (): Campaign | undefined => {
  const isBrowser = typeof window !== 'undefined';

  if (isBrowser) {
    const url = window.location.href;
    const data = getAllUrlParams(url);
    // console.log(data);
    return data;
  }

  return undefined;
};

export function handleExitComplete() {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0 });
  }
}

export function formatearMonedaMXN(numero: number): string {
  return numero.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
}

export const lockBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

export const unlockBodyScroll = () => {
  document.body.style.overflow = '';
};

export const calculateTimelineHeight = (
  container: HTMLElement | null,
  lastMedia: HTMLDivElement | null
) => {
  if (!container || !lastMedia) return;

  const containerRect = container.getBoundingClientRect();
  const lastMediaRect = lastMedia.getBoundingClientRect();

  const isLarge = window.innerWidth >= 992;
  const offset = isLarge ? 100 : 84;

  const lineEndFn = lastMediaRect.top + lastMediaRect.height;
  const lineStartFn = containerRect.top + offset;

  const height = lineEndFn - lineStartFn;

  if (height > 0) {
    container.style.setProperty('--line-height', `${height}px`);
  }
};
